import {get, post, del, patch, download, upload} from "../api"
import * as url from "../url"
import {format} from "react-string-format";

const apiGetCompaniesList = data => {
  return get(url.API_COMPANIES, data.history)
}

const apiPostCompaniesNew = data => {
  return post(url.API_COMPANIES, data.history, data.values)
}

const apiPatchCompaniesEdit = data => {
  return patch(url.API_COMPANIES + data.id + "/", data.history, data.values)
}

const apiDeleteCompaniesDelete = data => {
  return del(url.API_COMPANIES + data.id + "/", data.history)
}

const apiDownloadCompaniesExport = data => {
  return download(url.API_COMPANIES + "export-companies/", data.history, "companies.csv")
}

const apiUploadCompaniesImport = data => {
  return upload(url.API_COMPANIES + "import-companies/", data.history, data.file, {headers: {'Content-Type': 'multipart/form-data'}})
}

const apiGetCompaniesSimpleList = data => {
  return get(url.API_COMPANIES + "simple/", data.history)
}

const apiGetCompaniesGraph = data => {
  return get(format(url.API_COMPANIES_DETAIL, data.id) + "graph/", data.history)
}

export {
  apiGetCompaniesList,
  apiPostCompaniesNew,
  apiPatchCompaniesEdit,
  apiDeleteCompaniesDelete,
  apiDownloadCompaniesExport,
  apiUploadCompaniesImport,
  apiGetCompaniesSimpleList,
  apiGetCompaniesGraph,
}
